// extracted by mini-css-extract-plugin
var _1 = "TableModal-moduleboxWithOverlay__NdeEc";
var _2 = "TableModal-moduleconfirmation__oTOmR Modal-moduleModal__c1dw1";
var _3 = "TableModal-modulecontentWrapper__xG3VZ";
var _4 = "TableModal-modulepaginationPages__Iigri TablePaginationPages-moduleTablePaginationPages__bYPXC";
var _5 = "TableModal-modulerowSkeleton__mJebD TableSkeleton-moduleTableSkeletonRow__B_Tyw";
var _6 = "TableModal-moduletableScrollWrapper__xSI9q TableComponent-moduletableScrollWrapper__aUW0g";
var _7 = "TableModal-moduletableSkeleton__vvyWf TableSkeleton-moduleTableSkeletonInline__Ms4h1";
var _8 = "TableModal-modulevisible__RDFZT";
export { _1 as "boxWithOverlay", _2 as "confirmation", _3 as "contentWrapper", _4 as "paginationPages", _5 as "rowSkeleton", _6 as "tableScrollWrapper", _7 as "tableSkeleton", _8 as "visible" }
